import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface QuoteRequest {
  fullName: string;
  email: string;
  phone: string;
  company: string;
  cargoType: string;
  weight: string;
  details: string;
}

@Injectable({
  providedIn: 'root',
})
export class QuoteService {
  constructor(private readonly http: HttpClient) {}

  create(payload: QuoteRequest): Observable<unknown> {
    return this.http.post('/api/v1/quotes', payload);
  }
}
